import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { HorizontalSelectorComponent } from '../ready-for-contact-form/components/horizontal-selector/horizontal-selector.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgIf, UpperCasePipe } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
  selector: 'app-contact-form-content',
  imports: [
    NgIf,
    UpperCasePipe,
    TranslateModule,
    CheckboxComponent,
    CtaButtonComponent,
    HorizontalSelectorComponent,
    RouterLink,
    ReactiveFormsModule,
    InlineSVGModule
  ],
  templateUrl: './contact-form-content.component.html',
  styleUrl: './contact-form-content.component.scss',
})
export class ContactFormContentComponent {
  private readonly api = inject(ApiService);
  private readonly changeDetector = inject(ChangeDetectorRef);
  protected isOverlayOpen: boolean = false;
  protected isSuccess: boolean = false;
  protected isError: boolean = false;
  protected isSendTriggered: boolean = false;

  protected genders: string[] = ['mr', 'mrs', 'diverse'];

  protected form = new FormGroup({
    from: new FormControl('', [Validators.required, Validators.email]),
    subject: new FormControl('', [Validators.required]),
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    text: new FormControl('', [Validators.required]),
    company: new FormControl('', []),
    category: new FormControl('', []),
    gender: new FormControl(this.genders[0], []),
    isPrivacyChecked: new FormControl(false, [Validators.requiredTrue]),
  });

  @Input() recipient? = 'info@gerbion.com';

  @Input() public set category(v: string) {
    this.form.controls.category.setValue(v);
  }

  public get genderIndex(): number {
    return this.genders.indexOf(
      this.form.controls.gender.value ?? this.genders[0],
    );
  }

  protected changePrivacy(event: boolean) {
    this.form.controls.isPrivacyChecked.setValue(event);
  }

  protected updateGender(index: number) {
    this.form.controls.gender.setValue(this.genders[index]);
  }

  protected closeMessage() {
    if (this.isSuccess) {
      this.form.controls.from.setValue('');
      this.form.controls.subject.setValue('');
      this.form.controls.text.setValue('');
      this.form.controls.category.setValue('');
      this.form.controls.company.setValue('');
      this.form.controls.gender.setValue(this.genders[0]);
      this.form.controls.firstname.setValue('');
      this.form.controls.lastname.setValue('');
      this.form.markAsUntouched();
    }
    this.isOverlayOpen = false;
    this.isError = false;
    this.isSuccess = false;
    this.isSendTriggered = false;
    this.changeDetector.markForCheck();
  }

  protected openSuccessMessage() {
    this.isOverlayOpen = true;
    this.isSuccess = true;
    this.changeDetector.markForCheck();
  }

  protected openErrorMessage() {
    this.isOverlayOpen = true;
    this.isError = true;
    this.changeDetector.markForCheck();
  }

  protected send(event: Event) {
    event.preventDefault();
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSendTriggered = true;
    this.api.sendMail({
      from: this.form.controls.from.value || '',
      to: this.recipient,
      subject: this.form.controls.subject.value || '',
      text: this.form.controls.text.value || '',
      category: this.form.controls.category.value || '',
      company: this.form.controls.company.value || '',
      gender: this.form.controls.gender.value || '',
      firstname: this.form.controls.firstname.value || '',
      lastname: this.form.controls.lastname.value || '',
    }).subscribe({
      next: (result) => {
        this.openSuccessMessage();
      },
      error: (error) => {
        this.openErrorMessage();
      }
    });

  }
}
